// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_7cf8c15e","outerContainer":"_0d163155","secondaryToolbar":"f64eb6ce","doorHangerRight":"_6bedd3e8","toolbarContainer":"_1daee7fb","toolbarViewerMiddle":"_6d6feba7","progressBar":"_6ccb7e7b","back-to-application":"_55be25f8","root":"d75fa3d8","root--gray":"b1bac72d","root--unstyled":"c1d752bd","root--transparent":"dc0a9a32","root--column":"e748adac","root--overflow-visible":"_92515990"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Paper/index.styl
// module id = 5023
// module chunks = 39